/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VolumeUpdate
 */
export interface VolumeUpdate {
    /**
     * 
     * @type {string}
     * @memberof VolumeUpdate
     */
    path?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof VolumeUpdate
     */
    nodes: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof VolumeUpdate
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeUpdate
     */
    visualTag?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VolumeUpdate
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VolumeUpdate
     */
    useForHomes?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VolumeUpdate
     */
    useForWorkspaces?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VolumeUpdate
     */
    type?: VolumeUpdateTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof VolumeUpdate
     */
    snmEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VolumeUpdate
     */
    snfsName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VolumeUpdate
     */
    simulatedQuotas?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VolumeUpdate
     */
    cloudAccount?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum VolumeUpdateTypeEnum {
    Generic = 'generic',
    GenericMount = 'generic-mount',
    Snfs = 'snfs',
    Btrfs = 'btrfs',
    Lizardfs = 'lizardfs',
    Bcachefs = 'bcachefs',
    Onefs = 'onefs',
    Beegfs = 'beegfs',
    Cloud = 'cloud'
}

export function VolumeUpdateFromJSON(json: any): VolumeUpdate {
    return VolumeUpdateFromJSONTyped(json, false);
}

export function VolumeUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': !exists(json, 'path') ? undefined : json['path'],
        'nodes': json['nodes'],
        'displayName': !exists(json, 'display_name') ? undefined : json['display_name'],
        'visualTag': !exists(json, 'visual_tag') ? undefined : json['visual_tag'],
        'isDefault': !exists(json, 'is_default') ? undefined : json['is_default'],
        'useForHomes': !exists(json, 'use_for_homes') ? undefined : json['use_for_homes'],
        'useForWorkspaces': !exists(json, 'use_for_workspaces') ? undefined : json['use_for_workspaces'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'snmEnabled': !exists(json, 'snm_enabled') ? undefined : json['snm_enabled'],
        'snfsName': !exists(json, 'snfs_name') ? undefined : json['snfs_name'],
        'simulatedQuotas': !exists(json, 'simulated_quotas') ? undefined : json['simulated_quotas'],
        'cloudAccount': !exists(json, 'cloud_account') ? undefined : json['cloud_account'],
    };
}

export function VolumeUpdateToJSON(value?: VolumeUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'nodes': value.nodes,
        'display_name': value.displayName,
        'visual_tag': value.visualTag,
        'is_default': value.isDefault,
        'use_for_homes': value.useForHomes,
        'use_for_workspaces': value.useForWorkspaces,
        'type': value.type,
        'snm_enabled': value.snmEnabled,
        'snfs_name': value.snfsName,
        'simulated_quotas': value.simulatedQuotas,
        'cloud_account': value.cloudAccount,
    };
}


